import { api } from "@/api/client";

export const adminApi = {
  // Command Center — Business lower-panel workspace
  payouts: () => api.get("/admin/payouts").then((r) => r.data),
  apiBudget: () => api.get("/admin/api-budget").then((r) => r.data),
  accessRegistry: () => api.get("/admin/access-registry").then((r) => r.data),
  whitelist: (value) => api.post("/admin/access/whitelist", { value }).then((r) => r.data),
  whitelistRemove: (value) => api.post("/admin/access/whitelist/remove", { value }).then((r) => r.data),
  systemConfig: () => api.get("/admin/system-config").then((r) => r.data),
  registryStatus: (uid) => api.get(`/admin/registry-status${uid ? `?user_id=${encodeURIComponent(uid)}` : ""}`).then((r) => r.data),
  setSystemConfig: (body) => api.post("/admin/system-config", body).then((r) => r.data),
  wipeTemp: () => api.post("/admin/tools/wipe-temp").then((r) => r.data),
  setKnowledge: (body) => api.post("/admin/system-config/knowledge", body).then((r) => r.data),
  // Go-Live payments — Stripe catalogue seeding (founder only)
  stripeStatus: () => api.get("/billing/admin/stripe-status").then((r) => r.data),
  seedStripePrices: () => api.post("/billing/admin/seed-stripe-prices").then((r) => r.data),
  // Ad Maker tier control (founder only)
  userTiers: () => api.get("/admin/user-tiers").then((r) => r.data),
  updateUserTier: (body) => api.post("/admin/update-user-tier", body).then((r) => r.data),
  // Buy a Song funnel — read-only weekly/monthly totals (founder only)
  buySongStats: () => api.get("/admin/buy-song-stats").then((r) => r.data),
};
